import { useNavigate, useRoutes } from 'react-router-dom'

// import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
// import LocalizationProvider from '@mui/lab/LocalizationProvider'

import { CircularProgress, CssBaseline } from '@mui/material'
import ThemeProvider from './pages/admins/theme/ThemeProvider'
import { useEffect, useState } from 'react'
import routesDev from './routers/router-dev'
import routesPublic from './routers/router-public'
import routesAdmin from './routers/router-admin'
import { Helmet } from 'react-helmet-async'
import { useUser } from './contexts/UserContext'
import routesSupervisor from './routers/router-supervisor'
import routesClient from './routers/router-client'
import 'dayjs/locale/nl'
// import TermsDialog from './components/Terms'
import { global } from './constants/global'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { nl } from 'date-fns/locale'

// import { IPublicClientApplication } from '@azure/msal-browser'
// import { MsalProvider } from '@azure/msal-react'
// import { CustomNavigationClient } from './constants/NavigationClient'

// type AppProps = {
//   pca: IPublicClientApplication
// }

function App() {
  const { userData } = useUser()
  const navigate = useNavigate()
  const [role, setRole] = useState('')
  // const [acceptTerms, setAcceptTerms] = useState(false)

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!userData) {
      setLoading(false)
      // Tidak ada data pengguna, arahkan ke rute publik
      // navigate('/')
    } else {
      // Tentukan peran pengguna berdasarkan data pengguna
      switch (userData.roles) {
        case 'admin':
          console.log(userData)
          setRole('admin')
          break
        case 'dev':
          setRole('dev')
          break
        case 'supervisor':
          setRole('supervisor')
          break
        case 'client':
          setRole('client')
          break
        default:
          setRole('public')
          break
      }
    }
  }, [userData, loading])

  useEffect(() => {
    console.log(userData)
    if (!userData) {
      return
    }

    setLoading(false)
    const onboardingCompleted =
      localStorage.getItem('onboardingCompleted') === 'true'
    const onboardingRequired =
      userData.agreement === 'false' || userData.onboarding === 'false'
    const currentOnboardingStep =
      localStorage.getItem('currentOnboardingStep') || 'step1'

    // Jika onboarding dibutuhkan dan belum selesai
    if (userData.roles === 'client') {
      if (onboardingRequired && !onboardingCompleted) {
        // Jika saat ini user tidak berada di dalam alur onboarding
        if (!location.pathname.startsWith('/onboarding')) {
          navigate(`/onboarding/${currentOnboardingStep}`)
          return
        }
      }

      // Jika user berada di dashboard tanpa menyelesaikan onboarding
      if (location.pathname === '/dashboard' && !onboardingCompleted) {
        navigate(`/onboarding/${currentOnboardingStep}`)
      }
    }
  }, [userData, navigate, setLoading, role, location.pathname])

  useEffect(() => {
    if (global.environment == 'prod') {
      if (role === 'admin') {
        const script = document.createElement('script')
        script.src = 'https://cdn.feedbucket.app/assets/feedbucket.js'
        script.defer = true
        script.dataset.feedbucket = '97AQJi1EjE9CTivxag5N'
        document.head.appendChild(script)
      }
    } else {
      const script = document.createElement('script')
      script.src = 'https://cdn.feedbucket.app/assets/feedbucket.js'
      script.defer = true
      script.dataset.feedbucket = '58uJbtJq1ju42mVPW7JP'
      document.head.appendChild(script)
    }
  }, [role])

  // Tampilkan loading spinner atau indikator selama loading
  if (loading) {
    return <CircularProgress /> // Ganti dengan komponen loading yang sesuai
  }

  const routes = useRoutes(
    role === 'admin'
      ? routesAdmin
      : role === 'dev'
      ? routesDev
      : role === 'supervisor'
      ? routesSupervisor
      : role === 'client'
      ? routesClient
      : routesPublic
  )

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nl}>
        <CssBaseline />
        <Helmet>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
        </Helmet>
        {routes}
      </LocalizationProvider>
    </ThemeProvider>
  )
}
export default App
